import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';
import { InnerCircleProvider } from './context/InnerCircleContext';
import { EnquiryProvider } from './context/EnquiryContext';
import { Toaster } from './components/ui/sonner.jsx';
import Navigation from './components/Navigation';
import AnnouncementBar from './components/AnnouncementBar';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
// Levels page retired — /courses now redirects straight to /courses/1 (Grahita Śakti).
import LevelDetail from './pages/LevelDetail';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogEditor from './pages/BlogEditor';
import Footer from './components/Footer';
import TranslateBar from './components/TranslateBar';
import Books from './pages/Books';
import About from './pages/About';
import Guides from './pages/Guides';
import Community from './pages/Community';
import Contact from './pages/Contact';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import EnrollLevel1 from './pages/EnrollLevel1';
import Admin from './pages/Admin';
import SetPassword from './pages/SetPassword';
import Unsubscribe from './pages/Unsubscribe';
import MembershipPage from './pages/MembershipPage';
import InnerCirclePage from './pages/InnerCirclePage';
import '@/App.css';

// Tiny helper: preserves the :levelNumber path-param when redirecting
// the legacy /levels/:n URL to the canonical /courses/:n.
const LevelsRedirect = () => {
  const { levelNumber } = useParams();
  return <Navigate to={`/courses/${levelNumber}`} replace />;
};

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <InnerCircleProvider>
          <EnquiryProvider>
          <div className="App min-h-screen mystical-bg">
            <AnnouncementBar />
            <Navigation />
            <TranslateBar />
            <div style={{ paddingTop: 68 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/courses" element={<Navigate to="/courses/1" replace />} />
            <Route path="/courses/:levelNumber" element={<LevelDetail />} />
            {/* Legacy URLs — everything collapses to the single Grahita Śakti course page */}
            <Route path="/levels" element={<Navigate to="/courses/1" replace />} />
            <Route path="/levels/:levelNumber" element={<LevelsRedirect />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/new" element={<BlogEditor />} />
            <Route path="/blog/edit/:slug" element={<BlogEditor />} />
            <Route path="/blog/:postId" element={<BlogPost />} />
            <Route path="/books" element={<Books />} />
            <Route path="/about" element={<About />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/community" element={<Community />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/enroll/level-1" element={<EnrollLevel1 />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/account/membership" element={<MembershipPage />} />
            <Route path="/inner-circle" element={<InnerCirclePage />} />
          </Routes>
            </div>
          <Footer />
          <FloatingWhatsApp />
          <Toaster position="top-right" expand={true} richColors />
          </div>
          </EnquiryProvider>
          </InnerCircleProvider>
        </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
